import { BloomError } from '@jane/bloom/utils/errors/bloomError';

interface InitArgs {
  originalError?: unknown;
  request: {
    url: URL;
    verb: string;
  };
  response: {
    body: string;
    status: number;
  };
}

export class FetchError extends BloomError {
  constructor({ originalError, request, response }: InitArgs) {
    const { url, verb } = request;
    const { status } = response;

    const message = `${status} ${verb} ${url}`;
    super({
      context: {
        request,
        response,
      },
      fingerprint: `${verb}::${request.url.pathname}`,
      message,
      originalError,
    });
    this.name = 'FetchError';
  }
}
